import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { localeStrings as strings } from 'applicationConfig';
import ReportingDownloadGrid from './ReportingDownloadGrid';

import paths from '../../common/constants/paths';
import publisherTypes from '../../common/constants/publisherTypes';
import URLHelper from '../../utils/URLHelper';
import './reportingDownload.scss';

@inject('executionReportingStore')
@observer
class Reporting extends Component {
  componentDidMount() {
    const { publisherId, formattedDate } = this.props.location.state;
    this.props.executionReportingStore.loadReports({ datetext: formattedDate, publisher: publisherId });
  }

  componentWillMount() {
    if (!this.props.location.state) {
      // better not to use here react-router api redirect because of issues with MobX update
      URLHelper.redirect(paths.reporting);
    }
  }

  get reports() {
    return this.props.executionReportingStore.reports;
  }

  get items() {
    return this.reports.map(item => ({
      ...item,
      options: item.reports.map(report => ({ value: report.path, label: report.name }))
    }));
  }

  render() {
    const { name, formattedDate, publisherType } = this.props.location.state;
    const text = publisherType === publisherTypes.tradingVenue
      ? strings.executionReportingDownload.followingReportsAreAvailableFor
      : strings.executionReportingDownload.reportsAvailableFor;
    return (
      <div className="execution-reporting-download-page">
        <div className="execution-reporting-download-body">
          <p>{text} {name} {formattedDate}.</p>
          <p>{strings.executionReportingDownload.pleaseDownload}</p>
          <ReportingDownloadGrid data={this.items} type={publisherType}/>
        </div>
      </div>
    );
  }
}
export default Reporting;



// WEBPACK FOOTER //
// ./src/containers/ReportingDownload/ReportingDownload.jsx